import {
  alias,
  custom,
  identifier,
  serializable,
  SKIP,
  serialize,
} from 'serializr';

export abstract class Base {
  @serializable(identifier())
  public id: number | undefined;

  @serializable(
    alias(
      'createdAtEpoch',
      custom(
        () => SKIP,
        (v) => {
          if (v) return new Date(v);
        },
      ),
    ),
  )
  public createdAt: Date | undefined;

  @serializable(
    alias(
      'updatedAtEpoch',
      custom(
        () => SKIP,
        (v) => {
          if (v) return new Date(v);
        },
      ),
    ),
  )
  public updatedAt: Date | undefined;

  public serialize(): JSON {
    return serialize(this);
  }
}
